import { render } from "./Links.vue?vue&type=template&id=7c5b6ca2&scoped=true"
import script from "./Links.vue?vue&type=script&lang=js"
export * from "./Links.vue?vue&type=script&lang=js"

import "./Links.vue?vue&type=style&index=0&id=7c5b6ca2&scoped=true&lang=scss"

import exportComponent from "/home/caleb/Desktop/apps/kff_ordering_portal_claud/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c5b6ca2"]])

export default __exports__